import { NgModule } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { ReactiveFormsModule } from '@angular/forms';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import {
  CardsContainerComponent,
  ContactCardComponent as BaseContactCardComponent,
  DefaultCardComponent,
  SimpleCardComponent
} from '@iot-platform/iot-platform-ui';
import { InfoDisplayPipe } from '@iot-platform/pipes';
import { TranslatePipe } from '@ngx-translate/core';
import { ContactCardComponent } from './components/contact-card/contact-card.component';
import { GatewayCardComponent } from './components/gateway-card/gateway-card.component';
import { ProductCardComponent } from './components/product-card/product-card.component';
import { ThresholdCardComponent } from './components/threshold-card/threshold-card.component';

const COMPONENTS = [ProductCardComponent, ThresholdCardComponent, GatewayCardComponent, ContactCardComponent];

@NgModule({
  imports: [
    FlexLayoutModule,
    ReactiveFormsModule,
    MatInputModule,
    MatSelectModule,
    TranslatePipe,
    DefaultCardComponent,
    BaseContactCardComponent,
    CardsContainerComponent,
    SimpleCardComponent,
    InfoDisplayPipe
  ],
  declarations: COMPONENTS,
  exports: [DefaultCardComponent, ...COMPONENTS, CardsContainerComponent, SimpleCardComponent]
})
export class CardsModule {}
